<template>
    <div class="row">
        <editor-x v-if="loaded" :read-only="true" :programming-language="programmingLanguage" :code="code"
                  :additional-options="additionalOptions"></editor-x>
    </div>
</template>

<script>
    import EditorX from "../components/workspace/EditorX";

    export default {
        name: "read-only-editor",
        components: {EditorX},
        mounted() {
            let link = this.$route.query.link;
            this.programmingLanguage = this.$route.query.language;
            if (typeof this.programmingLanguage === "undefined") {
                this.programmingLanguage = "text"
            }

            let indentGuidesGetParameter = this.$route.query.renderIndentGuides;
            if (indentGuidesGetParameter === 'false') {
                this.additionalOptions["renderIndentGuides"] = false;
            }

            fetch(link)
                .then((response) => {
                    if (response.status !== 200) {
                        throw new Error(response.json().message);
                    }
                    return response.text()
                })
                .then((response) => {
                    this.code = response;
                    this.loaded = true;
                })
                .catch((error) => {
                    this.error = error;
                    console.warn(error);
                });


            this.$nextTick(function () {
                window.addEventListener('resize', this.calculateStyle);
            });

            this.calculateStyle();
        },
        data() {
            return {
                loaded: false,
                code: "",
                programmingLanguage: "text",
                additionalOptions: {},
            }
        },
        methods: {
            calculateStyle() {
                // Get the window height browser independently
                let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                // remove the header bar

                let navbar_height = 63;
                try {
                    navbar_height = document.getElementById('navbar_row').scrollHeight;
                } catch (err) {
                    console.error(err)
                }

                windowHeight = windowHeight - navbar_height - 13;
                this.height = `${windowHeight}px`;
            },
        }

    }
</script>

<style>
    #read-only-editor {
        background-color: white;
        padding: 0.5rem;
        overflow: hidden;
    }

    .main-content {
        padding-bottom: 0;
    }
</style>
